<template>
  <div>
    <v-container>
      <v-layout wrap class="pt-4">
        <v-flex xs12 class="text-sm-right text-xs-right">
          <v-btn depressed color="primary" @click="showSearch = true" class="ma-0 mr-1">
            <v-icon>search</v-icon>&nbsp;{{ $t('advanced search') }}
          </v-btn>
          <v-btn dark outline color="primary" @click="handleExportXlsx" :loading="loading">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <div class="primary-color mt-3" style="text-align: end">ทั้งหมด {{ total }} คน</div>
      <v-data-table
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="engineerList"
        :pagination.sync="pagination"
        class="elevation-1 mt-3"
      >
        <template slot="headerCell" slot-scope="props">
          <HeaderTableWithSort
            :headers="props.header"
            :sortBy.sync="sortBy"
            :orderBy.sync="orderBy"
            @onSort="handleChangeSort"
          ></HeaderTableWithSort>
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.unit_name || '-' }}</td>
            <td>{{ props.item.staff_id || '-' }}</td>
            <td>{{ props.item.full_name }}</td>
            <td>{{ props.item.phone_number }}</td>
            <td>{{ props.item.id_card }}</td>
            <td>{{ mapUserType[props.item.user_type] }}</td>
            <td class="text-xs-center">
              <template v-if="props.item.id_card_img">
                <v-btn flat icon color="primary" @click="handleShowImage(props.item.id_card_img)">
                  <v-icon>image</v-icon>
                </v-btn>
              </template>
              <template v-else>-</template>
            </td>
            <td class="text-xs-center">
              <v-btn flat icon color="primary" @click="handleShowImage(props.item.face_img)">
                <v-icon>image</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn outline fab small color="primary" @click="handleDeleteEngineer(props.item.id)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>

      <v-dialog v-model="showSearch" persistent width="700px">
        <SearchEngineerDialog
          @close="handleCloseSearch"
          @onSearch="onSearch"
        ></SearchEngineerDialog>
      </v-dialog>

      <v-dialog v-model="showDialogImage" persistent width="600px">
        <v-card class="pa-3">
          <div class="text-xs-right">
            <v-btn
              icon
              ripple
              @click="
                showDialogImage = false
                currentImage = null
              "
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div v-if="currentImage">
            <v-img :src="currentImage" max-width="600">
              <template v-slot:placeholder>
                <v-layout class="fill-height ma-0" justify-center align-center align-content-center>
                  <v-progress-circular
                    :size="48"
                    :color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-layout> </template
            ></v-img>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import yasaleAcApi from '@/api/yasale-ac'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import importxlsx from '@/components/elements/importxlsx.vue'
import SearchEngineerDialog from './SearchEngineerDialog.vue'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import { ORDER_BY } from '@/constants/orderBy.js'

export default {
  components: {
    importxlsx,
    SearchEngineerDialog,
    HeaderTableWithSort
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      importLoading: false,
      showSearch: false,
      loading: false,
      filter: {},
      engineerList: [],
      mapUserType: {
        guest: 'บุคคลภายนอก',
        staff: 'พนักงาน'
      },
      headers: [
        { text: 'ชื่อหน่วยงาน', value: 'unit_name', customSort: true, sortable: false },
        { text: 'รหัสพนักงาน', value: 'staff_id', customSort: true, sortable: false },
        { text: 'ชื่อ-สกุล', value: 'full_name', customSort: true, sortable: false },
        { text: 'เบอร์โทรศัพท์', value: 'phone_number', customSort: false, sortable: false },
        { text: 'เลขบัตรประจำตัวประชาชน', value: 'id_card', customSort: false, sortable: false },
        { text: 'ประเภทช่าง', value: 'user_type', customSort: true, sortable: false },
        { text: 'ภาพถ่ายบัตรประชาชน', value: 'id_card_img', customSort: false, sortable: false },
        { text: 'ภาพถ่ายใบหน้า', value: 'face_img', customSort: false, sortable: false },
        { text: '', customSort: false, sortable: false }
      ],
      showDialogImage: false,
      currentImage: null,
      sortBy: 'unit_name',
      orderBy: ORDER_BY.DESC
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.handleGetEngineer()
  },
  methods: {
    async handleGetEngineer() {
      const vm = this
      try {
        const response = await vm.getEngineer()
        if (response && response.data && response.total) {
          vm.engineerList = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getEngineer() {
      const vm = this
      return new Promise(async (resolve, reject) => {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset,
          sort_by: vm.sortBy,
          order_by: vm.orderBy,
          ...this.filter
        }

        vm.loading = true
        const response = await yasaleAcApi.getEngineer({
          config: {
            params: data
          }
        })

        vm.loading = false
        if (response && response.status === 200) {
          resolve(response.data)
        } else {
          reject(null)
        }
      })
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      const data = await vm.getEngineer()
      const engineerList = data.data
      vm.isExport = false

      if (engineerList == null) return
      const branchs = engineerList.map((el) => {
        return {
          unit_name: el.unit_name ? el.unit_name : '-',
          staff_id: el.staff_id ? el.staff_id : '-',
          full_name: el.full_name,
          phone_number: el.phone_number,
          id_card: el.id_card,
          id_card_img: el.id_card_img ? el.id_card_img : '-',
          face_img: el.face_img ? el.face_img : '-'
        }
      })

      const heading = [
        [
          'ชื่อหน่วยงาน',
          'รหัสพนักงาน',
          'ชื่อ-สกุล',
          'เบอร์โทรศัพท์',
          'เลขบัตรประจำตัวประชาชน',
          'ภาพถ่ายบัตรประชาชน',
          'ภาพถ่ายใบหน้า'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, branchs, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `yasale-ac-employee.xlsx`)
    },
    handleDeleteEngineer(id) {
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.deleteEngineer(id)
          }
        })
    },
    async deleteEngineer(id) {
      const vm = this
      try {
        let data = {
          page_id: vm.selectedBot.pageid
        }
        const response = await yasaleAcApi.deleteEngineer({ data: data }, id)
        if (response && response.status === 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.handleGetEngineer()
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    onSearch(payload) {
      this.filter = { ...payload }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showSearch = false
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleGetEngineer()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetEngineer()
    },
    handleChangeSort() {
      this.reset()
    },
    handleShowImage(url) {
      this.currentImage = url
      this.showDialogImage = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/EngineerList.vue